import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { api, formatApiError } from "@/lib/api";
import { SETTINGS } from "@/constants/testIds";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";

export default function ChangePasswordPage() {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next !== form.confirm) {
      setError("New passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/users/change-password", {
        current_password: form.current,
        new_password: form.next,
      });
      toast.success("Password updated");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout title="Change password" breadcrumbs={["Settings", "Security"]}>
      <form onSubmit={submit} className="max-w-md space-y-4" data-testid={SETTINGS.cpRoot}>
        <div className="rounded-2xl border border-slate-200 bg-white p-6 space-y-4">
          {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Current password</Label>
            <Input type="password" required value={form.current} onChange={set("current")} data-testid={SETTINGS.cpCurrent} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">New password</Label>
            <Input type="password" required value={form.next} onChange={set("next")} data-testid={SETTINGS.cpNew} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Confirm new password</Label>
            <Input type="password" required value={form.confirm} onChange={set("confirm")} data-testid={SETTINGS.cpConfirm} />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-md bg-[#101876] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0c135c] disabled:opacity-70"
          data-testid={SETTINGS.cpSubmit}
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}
          {loading ? "Updating…" : "Update password"}
        </button>
      </form>
    </DashboardLayout>
  );
}
